const Intro: React.FC = () => {
  return (
    <div>
      <h1>Intro</h1>
      <p>this is the intro page</p>
    </div>
  );
};

export default Intro;
